// src/lib/sms-sends-api.js — LOT 5 : client admin des ENVOIS Plateformes SMS.
//
// LECTURE : select direct de `message_sends` (policy admin, canal='sms') — la
// vue SMS lit aussi le corps porté par la ligne `messages` jointe.
//
// ÉCRITURE : action serveur `sms_send_save` UNIQUEMENT (requireAdmin +
// re-validation src/lib/sms-validator.js côté serveur). AUCUN
// `supabase.from('message_sends').insert/update` ne doit exister côté SMS :
// c'est le validateur (GSM-7, budget 160, whitelist de variables) qui rend
// l'écriture sûre, et il n'est pas contournable depuis la console navigateur
// tant que l'écriture passe par ici.
//
// ⚠️ LIMITE CONNUE (documentée, à lever par migration RLS) : la policy
// `admin_all` de `message_sends` reste FOR ALL pour l'admin authentifié → un
// admin déterminé PEUT encore écrire un send canal='sms' en direct. La
// migration `20260728000001_lot5_message_sends_sms_rls.sql` (ÉCRITE, NON
// APPLIQUÉE — STOP-GATE Dimitri) ferme ce trou avec un
// `WITH CHECK (canal <> 'sms')` sur INSERT/UPDATE côté client.

import { supabase } from "../supabase";

async function authHeaders() {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) throw new Error("Non authentifié");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

// Colonnes lues par la vue SMS. `messages(...)` porte le TEXTE (le corps d'un
// send n'est PAS dans message_sends — le moteur lit messages.body_<lang>).
export const SMS_SEND_COLUMNS =
  "id, message_id, status, canal, catchup_mode, trigger_type, " +
  "trigger_offset_value, trigger_offset_unit, trigger_time, " +
  "trigger_fixed_date, conditions, active_logement_ids, " +
  "messages(id, slug, name, category, body_fr, body_en, body_es)";

/**
 * Sauvegarde (création OU édition) d'un envoi SMS via l'action serveur.
 * @param {{send_id?:string, name?:string, body_fr:string, trigger_type:string,
 *   trigger_offset_value?:number, trigger_offset_unit?:string,
 *   trigger_time?:string, trigger_fixed_date?:string|null, conditions?:Array,
 *   active_logement_ids?:string[], status?:string, catchup_mode?:string}} payload
 * @returns {Promise<object>} { ok, op:'set', send_id, message_id, slug,
 *   warnings, worst_case, translations }
 * @throws {Error} avec `err.server` = payload d'erreur serveur (errors/detail)
 */
export async function saveSmsSend(payload) {
  const res = await fetch("/api/beds24-mapping?action=sms_send_save", {
    method: "POST",
    headers: await authHeaders(),
    body: JSON.stringify({ action: "sms_send_save", op: "set", ...payload }),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(json.detail || json.error || "Enregistrement de l'envoi SMS échoué");
    err.server = json;
    throw err;
  }
  return json;
}

/**
 * Suppression d'un envoi SMS (et de sa ligne `messages` dédiée) — même action
 * serveur, `op:'delete'`. Refuse tout send dont le canal n'est pas 'sms'.
 * @param {string} sendId
 * @returns {Promise<object>} { ok, op:'delete', send_id }
 */
export async function deleteSmsSend(sendId) {
  const res = await fetch("/api/beds24-mapping?action=sms_send_save", {
    method: "POST",
    headers: await authHeaders(),
    body: JSON.stringify({
      action: "sms_send_save",
      op: "delete",
      send_id: sendId,
    }),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(json.detail || json.error || "Suppression de l'envoi SMS échouée");
    err.server = json;
    throw err;
  }
  return json;
}
